import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { updateLegacySessionKey, setSiteRoutes } from '../../store/actions';
import {
  pullCampaignSiteCanvasses,
  pullCampaignSites,
  pullSiteRoutes,
  updateOrCreateRouteSeatSite,
  deleteRouteSeatSite,
  createRouteSeat,
  deleteRouteSeat,
  matchSiteCanvassToCampaign,
  pullCrews,
  pullCampaignCanvassers,
} from '../../store/api/calls';

import { siteCanvassEditCreateForm } from '../../utils/forms/formFields';
import { navigateAway } from '../../utils/nav';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import DataTable from '../theme/tables/DataTable';
import BaseModal from '../theme/modals/BaseModal';
import BaseForm from '../theme/forms/BaseForm';
import FeedbackTile from '../theme/modals/FeedbackTile';
import SiteRouteCard from '../cards/SiteRouteCard';
import Moment from 'moment';
import { Redirect } from 'react-router';
import Input from '../theme/forms/Input';

class SimpleSiteRouteEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editModalOpen: false,
      deleteModalOpen: false,
      editingInstance: {},
      feedbackTileVisibile: false,
      selectedSiteCanvass: 0,
      selectedSiteRoute: 0,
      addingToRouteSeatData: {},
      showAdHoc: false,
      addMode: false,
      showSuccess: false,
      showSuccessText: '',
      showFailure: false,
      showFailureText: '',
    };

    this.formInputs = siteCanvassEditCreateForm;
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    matchSiteCanvassToCampaign(params.sitecanvass_id)
      .then((sitecanvass_data) => this.setState({ selectedSiteCanvass: sitecanvass_data }))
      .then(() => pullSiteRoutes(params.sitecanvass_id))
      .then(() => {
        let sr = this.props.location.search
          ? this.props.location.search.match(/\?siteroute=(?<sr_id>\d+)/)
          : null;
        sr && this.setState({ selectedSiteRoute: sr[1] });
        console.log('SR check', sr);
      })
      .then(() => pullCampaignSites())
      .then(() =>
        pullCrews({ sitecanvass: params.sitecanvass_id, date: moment().format('YYYY-MM-DD') })
      )
      .then(() => pullCampaignCanvassers());
    // if (this.props.siteCanvasses.length && this.props.siteCanvasses[0].campaign === this.props.focusedCampaign.id) {
    //
    // }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.focusedCampaign.id &&
      this.props.focusedCampaign.id !== prevProps.focusedCampaign.id
    ) {
      console.log(this.props.focusedCampaign, prevProps.focusedCampaign);
      this.props.history.push('/sitecanvass');
    }
  }

  _filterKeysForDataTable() {
    let mapping;
    if (!this.state.showAdHoc) {
      mapping = (d) => ({
        add: (
          <button className="button button-outline" onClick={() => this.addSiteToSeat(d.id)}>
            + Add
          </button>
        ),
        _add: 0,
        name: d.name,
        description: d.description,
        address: d.addressline2 ? d.addressline1 + ', ' + d.addressline2 : d.addressline1,
        city: d.city,
        state: d.statecode,
        zip: d.zip5,
        created_at: new Moment(d.created_at).add(Moment().utcOffset(), 'm').format('MM/DD/YY'),
        _created_at: new Moment(d.created_at),
        _data: d,
      });

      return this.props.sites.filter((d) => d.site_type !== 'ad_hoc').map(mapping);
    } else {
      mapping = (d) => ({
        add: (
          <button className="button button-outline" onClick={() => this.addSiteToSeat(d.id)}>
            + Add
          </button>
        ),
        _add: 0,
        name: d.name,
        description: d.description,
        address: d.addressline2 ? d.addressline1 + ', ' + d.addressline2 : d.addressline1,
        city: d.city,
        state: d.statecode,
        zip: d.zip5,
        created_at: new Moment(d.created_at).add(Moment().utcOffset(), 'm').format('MM/DD/YY'),
        _created_at: new Moment(d.created_at),
        site_type: d.site_type,
        ad_hoc_date: d.ad_hoc_date
          ? new Moment(d.ad_hoc_date, 'YYYY-MM-DD').format('MM/DD/YY')
          : null,
        _ad_hoc_date: new Moment(d.ad_hoc_date, 'YYYY-MM-DD'),
        _data: d,
      });
      return this.props.sites.map(mapping);
    }
  }

  generateSiteCanvassOptions = () => {
    const options = this.props.siteCanvasses.map((d) => {
      return {
        value: d.id,
        display: d.name,
      };
    });

    options.unshift({ value: 0, display: '' });
    return options;
  };

  handleSiteCanvassSelection = (val) => {
    this.setState({ selectedSiteCanvass: val });
    pullSiteRoutes(val);
  };

  generateSiteRouteOptions = () => {
    const options = this.props.siteRoutes.map((d) => {
      return {
        value: d.siteroute_id,
        display: d.siteroute_name,
      };
    });
    options.unshift({ value: 0, display: ' ', disabled: true });
    return options;
  };

  handleSiteRouteSelection = (sr_id) => {
    this.props.history.push({
      search: `?siteroute=${sr_id}`,
    });
    this.setState({ selectedSiteRoute: sr_id });
  };

  showCallSuccessOrFailure = (successText, failureText) => {
    if (!this.props.error) {
      this.setState(
        {
          showSuccess: true,
          showSuccessText: successText,
          showFailure: false,
          showFailureText: '',
        },
        () => {
          setTimeout(() => this.setState({ showSuccess: false, showSuccessText: '' }), 2000);
        }
      );
    } else {
      this.setState(
        {
          showSuccess: false,
          showSuccessText: '',
          showFailure: true,
          showFailureText: failureText,
        },
        () => {
          setTimeout(() => this.setState({ showFailure: false, showFailureText: '' }), 2000);
        }
      );
    }
  };

  //first step where they tell us they want to add it
  handleAddSiteToSeatRequest = (data) => {
    this.setState({ addingToRouteSeatData: data, addMode: true }, () => {
      window.location = '#addsite';
    });
  };

  //they tell us what site they want to add
  addSiteToSeat = (siteID) => {
    // data example
    // {
    //     "site_order_position": 1,
    //     "routeseat": 1,
    //     "site": 1
    // }

    let rs = this.state.addingToRouteSeatData;
    let data_to_send = {
      site_order_position: rs.sites ? rs.sites.length + 1 : 0,
      routeseat: rs.routeseat_id,
      siteroute: this.state.selectedSiteRoute,
      site: siteID,
    };

    updateOrCreateRouteSeatSite(data_to_send).then(() =>
      this.showCallSuccessOrFailure('Site Added', 'Server Error. Failed to add site.')
    );
  };

  handleRemoveSiteFromSeat = (data) => {
    //takes {routeseatsite_id, routeseat_id}
    deleteRouteSeatSite({ ...data, siteroute_id: this.state.selectedSiteRoute }).then(() =>
      this.showCallSuccessOrFailure('Site Removed', 'Server Error. Failed to remove site.')
    );
  };

  handleAddSeat = () => {
    createRouteSeat({
      siteroute: this.state.selectedSiteRoute,
      canvasser_type: null,
    }).then(() => this.showCallSuccessOrFailure('Seat Added', 'Server Error. Failed to add seat.'));
  };

  handleRemoveSeat = (seat_id) => {
    deleteRouteSeat(seat_id, this.state.selectedSiteRoute).then(() =>
      this.showCallSuccessOrFailure('Seat Removed', 'Server Error. Failed to remove seat.')
    );
  };

  render() {
    return (
      <NavBaseTemplate
        location={this.props.location}
        history={this.props.history}
        disabled={true}
        showAdmin={this.props.is_admin}
      >
        <div className="button-table-top-wrapper">
          <div className="card wox-card">
            <h3 className="primary-text">Edit Route: {this.state.selectedSiteCanvass.name}</h3>
            <div className="row">
              <div className={`column column-50 ${this.props.siteRoutes.length ? '' : 'disabled'}`}>
                <Input
                  type="select"
                  title="Select a Site Route"
                  options={this.generateSiteRouteOptions()}
                  value={this.state.selectedSiteRoute || 0}
                  onChange={this.handleSiteRouteSelection}
                />
              </div>
            </div>
          </div>
        </div>

        {!!this.state.selectedSiteRoute && (
          <SiteRouteCard
            data={
              this.props.siteRoutes.find((d) => this.state.selectedSiteRoute == d.siteroute_id) ||
              {}
            }
            handleAddSite={this.handleAddSiteToSeatRequest}
            handleRemoveSite={this.handleRemoveSiteFromSeat}
            handleReorderSite={() => null}
            handleAddSeat={this.handleAddSeat}
            handleRemoveSeat={this.handleRemoveSeat}
            canvassers={this.props.canvassers}
            crews={this.props.crews}
          />
        )}

        {this.state.addMode && (
          <>
            <h3
              id="addsite"
              className="primary-text"
              style={{ paddingTop: '1.5em', marginTop: '.5em' }}
            >
              Add a site to {this.state.addingToRouteSeatData.type_name} seat in{' '}
              {
                (
                  this.props.siteRoutes.find(
                    (d) => this.state.selectedSiteRoute == d.siteroute_id
                  ) || {}
                ).siteroute_name
              }{' '}
            </h3>
            <div className="button-table-top-wrapper">
              <button
                className="button button-outline"
                onClick={() => this.setState({ addMode: false })}
              >
                Done
              </button>
              <Input
                type="checkbox"
                value={this.state.showAdHoc}
                onChange={() => {
                  this.setState({ showAdHoc: !this.state.showAdHoc });
                }}
                title="Show Ad Hoc Sites"
              />
            </div>
            <DataTable
              data={this._filterKeysForDataTable() || []}
              title="Assignable Sites"
              rowsToDisplay={50}
              displayFilter={true}
              filterText="Search for a site by name, description, address, or zipcode."
            />
          </>
        )}

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.props.loading}
        />

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-check-circle" style={{ marginRight: '15px' }} />
              {this.state.showSuccessText}
            </div>
          }
          classNames="success"
          visible={this.state.showSuccess}
        />

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-times" style={{ marginRight: '15px' }} />
              {this.state.showFailureText}
            </div>
          }
          classNames="danger"
          visible={this.state.showFailure}
        />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  canvassers: state.canvassers.data,
  focusedCampaign: state.session.focusedCampaign,
  siteCanvasses: state.siteCanvasses.data,
  siteRoutes: state.siteRoutes.data,
  sites: state.sites.data,
  crews: state.crews.data,
  loading: state.siteCanvasses.loading || state.siteRoutes.loading || state.campaigns.loading,
  error: state.siteCanvasses.error || state.siteRoutes.error,
  is_admin: state.permissions.is_admin,
});

//tHIS NEEDS tO MOVE tO tHE tEMPLAtE SCREEN!
const mapDispatchToProps = (dispatch) => ({
  setSiteRoutes: () => dispatch(setSiteRoutes({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(SimpleSiteRouteEdit));
